import { render, staticRenderFns } from "./TabPeople.vue?vue&type=template&id=4c80e0f2&scoped=true"
import script from "./TabPeople.vue?vue&type=script&lang=js"
export * from "./TabPeople.vue?vue&type=script&lang=js"
import style0 from "./TabPeople.vue?vue&type=style&index=0&id=4c80e0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80e0f2",
  null
  
)

export default component.exports